import { api } from "./client";
import type { LoginResponse, User } from "./types";
import type {
  ActivateAccountRequest,
  ActivateAccountResponse,
} from "@spectree/shared";

export interface SsoConfig {
  clientId: string;
  tenantId: string;
  redirectUri: string;
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>("/auth/login", { email, password }),

  refresh: (refreshToken: string) =>
    api.post<LoginResponse>("/auth/refresh", { refreshToken }),

  me: () => api.get<User>("/auth/me"),

  logout: () => api.post("/auth/logout", {}),

  activate: (data: ActivateAccountRequest): Promise<ActivateAccountResponse> =>
    api.post<ActivateAccountResponse>("/auth/activate", data),

  /** Fetch Microsoft Entra SSO configuration. */
  ssoConfig: () => api.get<SsoConfig>("/auth/sso/config"),

  /** Exchange authorization code + PKCE verifier for tokens. */
  ssoCallback: (code: string, codeVerifier: string) =>
    api.post<LoginResponse>("/auth/sso/callback", { code, codeVerifier }),
};
